<template>
  <router-link :to="{name: route}" class="block block-link-shadow text-center">
    <div class="block-content">
      <p class="mt-5">
        <i class="si fa-4x" :class="['si-' + icon, iconClass]"></i>
      </p>
      <p class="font-w600">{{label}}</p>
    </div>
  </router-link>
</template>

<script>
export default {
  props: [
    'label',
    'route',
    'icon',
    'iconClass'
  ]
}
</script>



// WEBPACK FOOTER //
// Tile.vue?0541a6ba